// Company details from the supplied website. Public references: DATA_SOURCES.txt.
export const company = {
  name: "Mechanic Professional Co., Ltd.",
  thaiName: "บริษัท เมคคานิก โปรเฟสชั่นแนล จำกัด",
  phone: "02-038-9533",
  phoneHref: "tel:+6620389533",
  fax: "02-038-9534",
  email: "promech12@hotmail.co.th",
  address: "38/46 หมู่ 14 ตำบลบึงคำพร้อย อำเภอลำลูกกา จังหวัดปทุมธานี 12150",
  englishAddress:
    "38/46 Moo 14, Bueng Kham Phroi, Lam Luk Ka, Pathum Thani 12150, Thailand",
  facebook: "https://www.facebook.com/mechanicmpc/",
  maps:
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(
      "บริษัท เมคคานิก โปรเฟสชั่นแนล จำกัด 38/46 หมู่ 14 บึงคำพร้อย ลำลูกกา ปทุมธานี 12150"
    ),
};

export const navigation = [
  { id: "home", label: "หน้าแรก" },
  { id: "about", label: "เกี่ยวกับเรา" },
  { id: "service", label: "บริการของเรา" },
  { id: "customer", label: "ลูกค้าของเรา" },
  { id: "contact", label: "ติดต่อเรา" },
];

export const serviceFilters = [
  { id: "all", label: "บริการทั้งหมด" },
  { id: "machinery", label: "งานเครื่องจักร" },
  { id: "systems", label: "งานระบบและโครงสร้าง" },
];

export const services = [
  {
    id: "maintenance",
    number: "01",
    category: "machinery",
    icon: "wrench",
    title: "ซ่อมบำรุงและ Overhaul",
    english: "MAINTENANCE & OVERHAUL",
    description:
      "ตรวจสอบ ปรับปรุง และซ่อมบำรุงเครื่องจักรอุตสาหกรรม ให้พร้อมสำหรับการใช้งาน",
    detail:
      "ดูแลเครื่องจักรอุตสาหกรรมด้วยงานตรวจสอบ ซ่อมแซม ปรับปรุง และ Overhaul โดยพิจารณารายละเอียดของเครื่องจักรและขอบเขตงานร่วมกับลูกค้า",
    scope: [
      "ตรวจสอบสภาพและปัญหาของเครื่องจักร",
      "ซ่อมบำรุงและปรับปรุงเครื่องจักร",
      "ถอดตรวจและ Overhaul ตามขอบเขตงาน",
    ],
    preparation:
      "ประเภทเครื่องจักร อาการที่พบ ภาพถ่าย และช่วงเวลาที่สะดวกให้ดำเนินงาน",
  },
  {
    id: "installation",
    number: "02",
    category: "machinery",
    icon: "machine",
    title: "ติดตั้ง ถอด และประกอบ",
    english: "INSTALLATION & ASSEMBLY",
    description:
      "บริการติดตั้ง ถอด และประกอบเครื่องจักร ตั้งแต่เครื่องจักรขนาดเล็กไปจนถึงขนาดใหญ่",
    detail:
      "รับติดตั้ง ถอด และประกอบเครื่องจักรกลอุตสาหกรรม โดยประสานรายละเอียดของเครื่องจักร พื้นที่ติดตั้ง และลำดับการทำงานให้เหมาะกับหน้างาน",
    scope: [
      "ติดตั้งเครื่องจักรอุตสาหกรรม",
      "ถอดและประกอบชิ้นส่วนเครื่องจักร",
      "ประสานขอบเขตงานตามสภาพพื้นที่",
    ],
    preparation:
      "ประเภท ขนาด และน้ำหนักเครื่องจักร พร้อมภาพถ่ายและข้อมูลพื้นที่ติดตั้ง",
  },
  {
    id: "relocation",
    number: "03",
    category: "machinery",
    icon: "move",
    title: "ขนย้ายเครื่องจักรและไลน์ผลิต",
    english: "MACHINERY RELOCATION",
    description:
      "เคลื่อนย้ายเครื่องจักรและไลน์การผลิต ทั้งภายในโรงงานและระหว่างสถานที่",
    detail:
      "รับงานขนย้ายเครื่องจักรและไลน์การผลิต ทั้งภายในและภายนอกโรงงาน โดยหารือรายละเอียดของต้นทาง ปลายทาง และข้อจำกัดของพื้นที่ก่อนกำหนดขอบเขตงาน",
    scope: [
      "ขนย้ายเครื่องจักรภายในโรงงาน",
      "ย้ายเครื่องจักรระหว่างสถานที่",
      "ขนย้ายไลน์การผลิต",
    ],
    preparation:
      "ขนาด น้ำหนัก จำนวนเครื่องจักร สถานที่ต้นทาง–ปลายทาง และกำหนดการที่ต้องการ",
  },
  {
    id: "piping",
    number: "04",
    category: "systems",
    icon: "pipe",
    title: "ระบบท่อ ปั๊ม และวาล์ว",
    english: "PIPING, PUMPS & VALVES",
    description:
      "งานติดตั้งและดูแลระบบท่อ ปั๊ม และวาล์ว สำหรับการใช้งานในโรงงานอุตสาหกรรม",
    detail:
      "ให้บริการงานระบบท่ออุตสาหกรรม ปั๊ม และวาล์ว โดยพิจารณารายละเอียดของระบบ ลักษณะการใช้งาน และพื้นที่หน้างานร่วมกัน",
    scope: [
      "งานติดตั้งท่ออุตสาหกรรม",
      "งานปั๊มและวาล์ว",
      "ปรับปรุงระบบตามขอบเขตที่ตกลง",
    ],
    preparation:
      "ชนิดของระบบ ขนาดท่อ ลักษณะการใช้งาน และแบบหรือภาพถ่ายหน้างานที่มี",
  },
  {
    id: "hydraulic",
    number: "05",
    category: "systems",
    icon: "hydraulic",
    title: "ซ่อมระบบไฮดรอลิก",
    english: "HYDRAULIC SYSTEMS",
    description:
      "รับซ่อมระบบไฮดรอลิกของเครื่องจักรอุตสาหกรรม ตามลักษณะปัญหาและการใช้งาน",
    detail:
      "รับงานซ่อมระบบไฮดรอลิกสำหรับเครื่องจักรอุตสาหกรรม แจ้งข้อมูลระบบและอาการที่พบเพื่อให้ทีมงานสอบถามรายละเอียดก่อนประเมินงาน",
    scope: [
      "ตรวจสอบรายละเอียดปัญหาระบบไฮดรอลิก",
      "งานซ่อมระบบไฮดรอลิก",
      "กำหนดขอบเขตงานตามลักษณะเครื่องจักร",
    ],
    preparation:
      "รุ่นเครื่องจักร ข้อมูลระบบไฮดรอลิก อาการที่พบ และภาพถ่ายอุปกรณ์",
  },
  {
    id: "structure",
    number: "06",
    category: "systems",
    icon: "structure",
    title: "งานโครงสร้างและงานเชื่อม",
    english: "STRUCTURAL & WELDING WORK",
    description:
      "บริการงานโครงสร้าง งานเชื่อม และงานตัด เพื่อรองรับงานเครื่องจักรและพื้นที่อุตสาหกรรม",
    detail:
      "รับงานโครงสร้าง งานเชื่อม และงานตัด โดยพิจารณารูปแบบ ขนาด และรายละเอียดการใช้งานตามแบบหรือขอบเขตที่ลูกค้าต้องการ",
    scope: [
      "งานโครงสร้างสำหรับภาคอุตสาหกรรม",
      "งานเชื่อมและงานตัด",
      "ประสานรายละเอียดแบบและพื้นที่ติดตั้ง",
    ],
    preparation:
      "แบบงาน ขนาด วัสดุที่ต้องการ ลักษณะการใช้งาน และภาพถ่ายพื้นที่",
  },
];
